<template>
  <v-container>
    <v-layout align-center>
      <v-flex xs10>
        <h3 class="primary--text">Negócios Pessoas - Primeiro Contato</h3>
      </v-flex>
    </v-layout>
    <v-layout justify-space-around row wrap>
      <v-flex xs12>
        <v-card class="default-border" flat>
          <v-layout>
            <v-flex xs3>
              <v-card>
                <v-card-title class="green white--text">
                  <span class="title">Dias 0-20</span>
                  <v-spacer></v-spacer>
                  <span> Qt. {{ lista020.length }} </span>
                </v-card-title>
                <v-list two-line>
                  <template v-for="(item, index) in lista020">
                    <v-list-tile
                      :key="`${index}-${item.idPessoa}`"
                      avatar
                      ripple
                      @click="verPessoa(cipherComputed.encrypt(item.idPessoa))"
                    >
                      <v-list-tile-content>
                        <v-list-tile-title>{{ item.nome }}</v-list-tile-title>
                        <v-list-tile-sub-title class="text--primary">{{
                          item.usuarioNome
                        }}</v-list-tile-sub-title>
                        <v-list-tile-sub-title
                          >Dias: {{ item.numeroDeDias }}</v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                      <v-list-tile-avatar>
                        <img
                          :src="`${
                            item.usuarioAvatar
                              ? item.usuarioAvatar
                              : defaultAvatar
                          }`"
                        />
                      </v-list-tile-avatar>
                    </v-list-tile>
                    <v-divider
                      v-if="index + 1 < lista020.length"
                      :key="index"
                    ></v-divider>
                  </template>
                </v-list>
              </v-card>
            </v-flex>
            <v-flex xs3>
              <v-card>
                <v-card-title class="blue white--text">
                  <span class="title">Dias 21-30</span>
                  <v-spacer></v-spacer>
                  <span> Qt. {{ lista2130.length }} </span>
                </v-card-title>
                <v-list two-line>
                  <template v-for="(item, index) in lista2130">
                    <v-list-tile
                      :key="`${index}-${item.idPessoa}`"
                      avatar
                      ripple
                      @click="verPessoa(cipherComputed.encrypt(item.idPessoa))"
                    >
                      <v-list-tile-content>
                        <v-list-tile-title>{{ item.nome }}</v-list-tile-title>
                        <v-list-tile-sub-title class="text--primary">{{
                          item.usuarioNome
                        }}</v-list-tile-sub-title>
                        <v-list-tile-sub-title
                          >Dias: {{ item.numeroDeDias }}</v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                      <v-list-tile-avatar>
                        <img
                          :src="`${
                            item.usuarioAvatar
                              ? item.usuarioAvatar
                              : defaultAvatar
                          }`"
                        />
                      </v-list-tile-avatar>
                    </v-list-tile>
                    <v-divider
                      v-if="index + 1 < lista2130.length"
                      :key="index"
                    ></v-divider>
                  </template>
                </v-list>
              </v-card>
            </v-flex>
            <v-flex xs2>
              <v-card>
                <v-card-title class="yellow white--text">
                  <span class="title">Dias 31- 60</span>
                  <v-spacer></v-spacer>
                  <span> Qt. {{ lista3160.length }} </span>
                </v-card-title>
                <v-list two-line>
                  <template v-for="(item, index) in lista3160">
                    <v-list-tile
                      :key="`${index}-${item.idPessoa}`"
                      avatar
                      ripple
                      @click="verPessoa(cipherComputed.encrypt(item.idPessoa))"
                    >
                      <v-list-tile-content>
                        <v-list-tile-title>{{ item.nome }}</v-list-tile-title>
                        <v-list-tile-sub-title class="text--primary">{{
                          item.usuarioNome
                        }}</v-list-tile-sub-title>
                        <v-list-tile-sub-title
                          >Dias: {{ item.numeroDeDias }}</v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                      <v-list-tile-avatar>
                        <img
                          :src="`${
                            item.usuarioAvatar
                              ? item.usuarioAvatar
                              : defaultAvatar
                          }`"
                        />
                      </v-list-tile-avatar>
                    </v-list-tile>
                    <v-divider
                      v-if="index + 1 < lista3160.length"
                      :key="index"
                    ></v-divider>
                  </template>
                </v-list>
              </v-card>
            </v-flex>
            <v-flex xs2>
              <v-card>
                <v-card-title class="blue-grey white--text">
                  <span class="title">Dias 61-120</span>
                  <v-spacer></v-spacer>
                  <span> Qt. {{ lista61120.length }} </span>
                </v-card-title>
                <v-list two-line>
                  <template v-for="(item, index) in lista61120">
                    <v-list-tile
                      :key="`${index}-${item.idPessoa}`"
                      avatar
                      ripple
                      @click="verPessoa(cipherComputed.encrypt(item.idPessoa))"
                    >
                      <v-list-tile-content>
                        <v-list-tile-title>{{ item.nome }}</v-list-tile-title>
                        <v-list-tile-sub-title class="text--primary">{{
                          item.usuarioNome
                        }}</v-list-tile-sub-title>
                        <v-list-tile-sub-title
                          >Dias: {{ item.numeroDeDias }}</v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                      <v-list-tile-avatar>
                        <img
                          :src="`${
                            item.usuarioAvatar
                              ? item.usuarioAvatar
                              : defaultAvatar
                          }`"
                        />
                      </v-list-tile-avatar>
                    </v-list-tile>
                    <v-divider
                      v-if="index + 1 < lista61120.length"
                      :key="index"
                    ></v-divider>
                  </template>
                </v-list>
              </v-card>
            </v-flex>
            <v-flex xs2>
              <v-card>
                <v-card-title class="red white--text">
                  <span class="title">Dias +120</span>
                  <v-spacer></v-spacer>
                  <span> Qt. {{ lista120mais.length }} </span>
                </v-card-title>
                <v-list two-line>
                  <template v-for="(item, index) in lista120mais">
                    <v-list-tile
                      :key="`${index}-${item.idPessoa}`"
                      avatar
                      ripple
                      @click="verPessoa(cipherComputed.encrypt(item.idPessoa))"
                    >
                      <v-list-tile-content>
                        <v-list-tile-title>{{ item.nome }}</v-list-tile-title>
                        <v-list-tile-sub-title class="text--primary">{{
                          item.usuarioNome
                        }}</v-list-tile-sub-title>
                        <v-list-tile-sub-title
                          >Dias: {{ item.numeroDeDias }}</v-list-tile-sub-title
                        >
                      </v-list-tile-content>
                      <v-list-tile-avatar>
                        <img
                          :src="`${
                            item.usuarioAvatar
                              ? item.usuarioAvatar
                              : defaultAvatar
                          }`"
                        />
                      </v-list-tile-avatar>
                    </v-list-tile>
                    <v-divider
                      v-if="index + 1 < lista120mais.length"
                      :key="index"
                    ></v-divider>
                  </template>
                </v-list>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import cipher from "@/helpers/cipher.js";
import jwt from "@/helpers/jwt";

export default {
  name: "NegociosPessoaPrimeiroContato",
  data: () => ({
    defaultAvatar: "/static/images/default-user.png",

    lista020: [],
    lista2130: [],
    lista3160: [],
    lista61120: [],
    lista120mais: [],
  }),
  mounted: function () {
    this.buscarPessoas();
  },
  computed: {
    cipherComputed: function () {
      return cipher;
    },
  },
  methods: {
    buscarPessoas: function () {
      const self = this;
      self.$http
        .get(
          `${process.env.URL_API}/negociopessoa/v1/painel/primeiroContato/busca/conta/` +
            jwt.decryptToken().idconta,
          {
            headers: {
              Authorization:
                "Bearer " + JSON.parse(localStorage.getItem("token")),
            },
          }
        )
        .then(function (response) {
          const data = response.data;
          console.log(data);

          data.forEach((e) => {
            if (e.numeroDeDias <= 20) {
              self.lista020.push(e);
            }
            if (e.numeroDeDias >= 21 && e.numeroDeDias <= 30) {
              self.lista2130.push(e);
            }
            if (e.numeroDeDias >= 31 && e.numeroDeDias <= 60) {
              self.lista3160.push(e);
            }
            if (e.numeroDeDias >= 61 && e.numeroDeDias <= 120) {
              self.lista61120.push(e);
            }
            if (e.numeroDeDias > 120) {
              self.lista120mais.push(e);
            }
          });
          self.lista020.sort((a, b) => parseFloat(b.numeroDeDias) - parseFloat(a.numeroDeDias));
          self.lista2130.sort((a, b) => parseFloat(b.numeroDeDias) - parseFloat(a.numeroDeDias));
          self.lista3160.sort((a, b) => parseFloat(b.numeroDeDias) - parseFloat(a.numeroDeDias));
          self.lista61120.sort((a, b) => parseFloat(b.numeroDeDias) - parseFloat(a.numeroDeDias));
          self.lista120mais.sort((a, b) => parseFloat(b.numeroDeDias) - parseFloat(a.numeroDeDias));

        });
    },
    verPessoa(id) {
      const self = this;
      self.$router.push({ name: "StatusPessoa", params: { id: id } });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/negocio/NegociosPessoaPrimeiroContato.vue